import { createEmIcon } from '../designSystemIcons';

export const SignatureTextIcon = createEmIcon('font-case');
